/**
 * Defines a person who appeared on the order
 */
export class Appearance {
}
